import getRequest from '@/client/utils/getRequest'
import { basePath } from '@/next.config'

export const clientGetRelatedTracks = async (
	trackId: number
): Promise<Track[]> => {
	const tracks = await getRequest<Track[]>(
		`${basePath}/api/musicapp/music/tracks/related?trackId=${trackId}`,
		'related tracks'
	)

	return tracks ?? []
}
